import { AppState } from 'slices/app';
import useSelector from './useSelector';

const useUser = (): AppState['user'] => useSelector((state) => state.app.user);

export default useUser;
